import { LostAndFoundIssueWithCacheReturnStatusEnum } from '@/models/gen/graphql';

export const returnStatusDisplay = (status: LostAndFoundIssueWithCacheReturnStatusEnum) => {
  switch (status) {
    case 'RETURNED':
      return 'Returned';
    case 'SHIPPED':
      return 'Shipped';
    case 'REPORTED_LOST':
      return 'Reported Lost';
    case 'UNCLAIMED':
      return 'Unclaimed';
    default:
      return ''; // TODO: Maybe return Uknown?
  }
};
